import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "4accfac3-b4f8-4dda-a0db-b11ae7b1a96e",
    content: "0.01 Pa, i.e., -40 dB without absorption and<br>0.004 Pa, i.e., -49 dB accounting for absorption.",
    options: {},
  },
  {
    id: "e8bad7b0-fd1a-499c-9a3e-62c0651f328d",
    content: "0.02 Pa, i.e., -39 dB without absorption and<br>0.002 Pa, i.e., -50 dB accounting for absorption.",
    options: {},
  },
  {
    id: "96b778a7-3084-4111-bca3-bc6796556134",
    content: "0.01 Pa, i.e., -41 dB without absorption and<br>0.005 Pa, i.e., -49 dB accounting for absorption.",
    options: {},
  },
  {
    id: "5e2b8d56-a2a1-496b-bcf6-40e79acb5b08",
    content: "0.03 Pa, i.e., -39 dB without absorption and<br>0.003 Pa, i.e., -47 dB accounting for absorption.",
    options: {},
  },
];

export const task: Task = {
  id: "48ee1ab2-5e52-4eaa-82d7-ac728d642bc6",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4accfac3-b4f8-4dda-a0db-b11ae7b1a96e"],
};
